/**
 * @generated SignedSource<<2e9ae36f2c1ce1fca92e6e24bfbb87eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraIssueDeploymentEnvironmentState = "DEPLOYED" | "NOT_DEPLOYED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference$data = ReadonlyArray<{
  readonly node: {
    readonly devOpsSummarisedEntities?: {
      readonly summarisedBuilds?: {
        readonly count: number | null | undefined;
      } | null | undefined;
      readonly summarisedDeployments?: {
        readonly count: number | null | undefined;
      } | null | undefined;
      readonly summarisedFeatureFlags?: {
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly devSummaryCache?: {
      readonly devSummary: {
        readonly branch: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly build: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly commit: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly deploymentEnvironments: {
          readonly overall: {
            readonly topEnvironments: ReadonlyArray<{
              readonly status: JiraIssueDeploymentEnvironmentState | null | undefined;
            }> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly pullrequest: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly review: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly summarisedBuilds?: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly summarisedDeployments?: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly summarisedFeatureFlags?: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges">;
  readonly " $fragmentType": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference";
}>;
export type screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference$key = ReadonlyArray<{
  readonly " $data"?: screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v1 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v0/*: any*/)
},
v2 = {
  "concreteType": "DevOpsSummarisedFeatureFlags",
  "kind": "LinkedField",
  "name": "summarisedFeatureFlags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalCount"
    }
  ]
},
v3 = {
  "concreteType": "DevOpsSummarisedBuilds",
  "kind": "LinkedField",
  "name": "summarisedBuilds",
  "plural": false,
  "selections": (v0/*: any*/)
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    },
    {
      "kind": "RootArgument",
      "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    },
    {
      "kind": "RootArgument",
      "name": "shouldIncludeDevOpsFieldsViaAgs"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "condition": "isDevopsFeatureDisabledInFedRamp",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "DevOpsSummarisedEntities",
              "kind": "LinkedField",
              "name": "devOpsSummarisedEntities",
              "plural": false,
              "selections": [
                {
                  "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ]
                }
              ]
            },
            {
              "concreteType": "JiraIssueDevSummaryResult",
              "kind": "LinkedField",
              "name": "devSummaryCache",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueDevSummary",
                  "kind": "LinkedField",
                  "name": "devSummary",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "pullrequest",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssuePullRequestDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueBranchDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "branch",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueBranchDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueReviewDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "review",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueReviewDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueCommitDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "commit",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueCommitDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueBuildDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "build",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueBuildDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                      "kind": "LinkedField",
                      "name": "deploymentEnvironments",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "JiraIssueDeploymentEnvironment",
                              "kind": "LinkedField",
                              "name": "topEnvironments",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "status"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "condition": "shouldIncludeDevOpsFieldsViaAgs",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/)
          ]
        },
        {
          "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            (v2/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges"
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "ea60645c920c025333573ec5ba26fd4d";

export default node;
